import { analyticsUtils } from 'utils';

export const clickEvent = (
  text: string | undefined,
  element: string | undefined,
  isAccordion: boolean,
  currentLevel?: number,
  isFlexible?: boolean,
  path?: string,
) => {
  const nextLevel = (currentLevel || 0) + 1;
  const eventData = {
    elementType: 'button',
    elementBlock: `/catalogue/:lvl0`,
    elementName: `${element}`,
    elementText: `${text}`,
    ...(!isAccordion && {
      elementVariant: `${path}:lvl${nextLevel}`,
      isFlexible: isFlexible ? '1' : '0',
    }),
  };

  analyticsUtils.sendEvent('GA:clickButton', eventData);
};
